import GlobalProvider from "./src/context/GlobalProvider"
import "./src/styles/global.css"
import React from 'react';
import { ClerkProvider } from '@clerk/clerk-react';

// Suppress only Gatsby navigation-related unhandled rejections.
// Do not suppress generic app-level network errors.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", event => {
    const msg =
      event?.reason?.message || (typeof event?.reason === "string" ? event.reason : "")
    const stack = event?.reason?.stack || ""
    const context = `${msg}\n${stack}`

    // Always suppress known Gatsby loadPage navigation failures.
    if (/loadPage/i.test(context)) {
      event.preventDefault()
      return
    }

    const isNetworkError =
      /Failed to fetch/i.test(msg) ||
      /Load failed/i.test(msg) ||
      /NetworkError/i.test(msg) ||
      /The network connection was lost/i.test(msg)

    const isGatsbyNavigationContext =
      /___loader/i.test(context) ||
      /page-data/i.test(context) ||
      /async-requires/i.test(context) ||
      /gatsby[\\/].*loader/i.test(context)

    if (isNetworkError && isGatsbyNavigationContext) {
      event.preventDefault()
    }
  })
}

export const wrapPageElement = ({ element, props }) => (
  <ClerkProvider publishableKey={process.env.GATSBY_CLERK_PUBLISHABLE_KEY}>
    <GlobalProvider {...props}>{element}</GlobalProvider>
  </ClerkProvider>
)
export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  return prevRouterProps?.location?.pathname !== routerProps.location.pathname
}
